<cb-dialog [dialogHeading]="isEdit() ? 'Edit Filter' : 'New Filter'">
    <form #filterForm="ngForm">
        <div class="flex-row">
            <cb-input
                label="Filter Name"
                name="filterName"
                [(ngModel)]="mappedItem.name"
                [required]="true"
                [maxlength]="100"
                [disabled]="reorderingEnabled"
            ></cb-input>
            <cb-checkbox
                label="Active"
                name="active"
                [(ngModel)]="mappedItem.isActive"
                [disabled]="reorderingEnabled"
            ></cb-checkbox>
        </div>
        <cb-table label="Attributes" [stringColumns]="attributeColumns" [loaded]="true">
            <tbody
                cbTableBody
                cdkDropList
                [cdkDropListDisabled]="!reorderingEnabled"
                [cdkDropListData]="mappedItem.attributes"
                (cdkDropListDropped)="drop($event)"
            >
                @for (attribute of mappedItem.attributes; track attribute; let i = $index) {
                    <tr
                        cdkDrag
                        cdkDragPreviewClass="cb-table-drag-preview"
                        class="drag-item"
                        [cdkDragDisabled]="!reorderingEnabled"
                    >
                        @if (reorderingEnabled) {
                            <td>
                                <mat-icon
                                    class="drag-handle drag-handle-icon"
                                    fontSet="material-symbols-outlined"
                                    >drag_indicator</mat-icon
                                >
                            </td>
                        }
                        <td>
                            <cb-td-icon
                                svgValue="information-outline"
                                [toolTip]="attribute.description"
                                class="cb-grey"
                            >
                            </cb-td-icon>
                        </td>
                        <cb-td-text [value]="attribute.matchValue"></cb-td-text>
                        <cb-td-checkbox [value]="attribute.isRegex"></cb-td-checkbox>
                        <cb-td-checkbox [value]="attribute.isActive"></cb-td-checkbox>
                        <td>
                            {{ getPrerequisiteFilterName(attribute.prerequisiteFilterMatchId) }}
                        </td>
                        <td>{{ attribute.prerequisiteFilterMatchValue ?? '' }}</td>
                        @if (!reorderingEnabled) {
                            <td cbTableStickyCol="end" cbTableShrinkCol>
                                <button
                                    class="cb-margin-right"
                                    mat-icon-button
                                    (click)="editAttribute(attribute)"
                                >
                                    <mat-icon> edit </mat-icon>
                                </button>
                                <button mat-icon-button (click)="removeFilterAttribute(i)">
                                    <mat-icon> remove_circle </mat-icon>
                                </button>
                            </td>
                        }
                    </tr>
                }
                <tr class="cb-table-footer-row">
                    <td colspan="6">
                        @if (canReorderAttributes) {
                            <mat-slide-toggle
                                name="reorderingEnabled"
                                [checked]="reorderingEnabled"
                                (click)="reorderingEnabled = !reorderingEnabled"
                            >
                                Enable Reordering
                            </mat-slide-toggle>
                        }
                    </td>
                    <td cbTableStickyCol="end" cbTableShrinkCol>
                        <button
                            mat-icon-button
                            (click)="addAttribute()"
                            [disabled]="reorderingEnabled"
                        >
                            <mat-icon> add </mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </cb-table>
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="
                filterForm.invalid || reorderingEnabled || (filterForm.pristine && !dataChanged)
            "
            (cbClick)="save()"
            [clickLimit]="1"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
